//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    labels: {
      type: Object,
      default: () => ({
        tab1: 'Buscar',
        tab2: 'Añadir',
      }),
    },
  },
  data() {
    return {
      activeTab: this.value,
    }
  },
  watch: {
    activeTab(newValue) {
      this.$emit('input', newValue)
    },
  },
}
